<template>
  <v-layout class="inner-pages" column>
    <Header />

    <scroll-data :footer="false">

      <v-layout  fill-height>
        <v-flex xs12 mt-5 pt-5>
          <v-flex class="headline text-xs-center">Loading...</v-flex>
        </v-flex>
      </v-layout>

    </scroll-data>
  </v-layout>

</template>

<script>
  import ScrollData from '../ScrollData'
  import Header from '../layouts/Header'
  import {mapGetters, mapMutations} from 'vuex'
  import crypto from '@/mixins/crypto'

  // function isEmpty (obj) {
  //   return Object.keys(obj).length === 0
  // }
  export default {
    name: 'Programs',
    components: {Header, ScrollData},
    data () {
      return {
        footer: false,
        courseId: process.env.GAME_ID,
        apiUrl: process.env.API_URL
      }
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails']),
      groups: function () {
        return this.$store.getters['course/getGroups']
      },
      userId () {
        return this.user.id ? this.user.id : 0
      },
      user () {
        return this.$store.getters['user/getUserDetails']
      }
    },
    mounted () {
      // console.log('Initializing Dashboard group details', this.groups)
      // console.log('this.userId', this.userId)
      this.initPage()
    },
    methods: {
      ...mapMutations('registration', [
        'setUser'
      ]),
      initPage () {
        if (this.groups.length === 0) {
          this.initiateDashboard()
        } else {
          this.goToProgramLevel()
        }
      },
      goToProgramLevel () {
        if (this.isProgramDetailPage() === true && this.userId) {
          // console.log('======== LEAVING to PROGRAM 1 LEVELS=========')
          // console.log('USER', this.user)
          // console.log('userId', this.userId)
          // console.log('=================')
          const deckId = this.groups[0].decks[0].id
          const groupId = this.groups[0].groupId
          this.$router.push({name: 'ProgramLevels', params: {deckId, groupId}})
        }
      },

      isProgramDetailPage () {
        return this.groups.length === 1 || typeof this.$route.params.deckId !== 'undefined'
      },
      initiateDashboard () {
        // console.log('Dashboard Initialized')
        // to confirm if group is already fetched
        // console.log('Groups', this.groups)
        if (this.groups.length === 0) {
          this.$store.dispatch('course/fetchAvailablePrograms')
        }
      },
      checkIfUserIsRegistered () {
        const group = this.groups.find(group => group.decks[0].regId === this.courseId)
        if (group) {
          if (this.userId) {
            // console.log('User Registered', group)
            // console.log('======== LEAVING to PROGRAM 2 LEVELS=========')
            // console.log('userId', this.userId)
            // console.log('=================')
            const deckId = group.decks[0].id
            const groupId = group.groupId
            this.$router.push({name: 'ProgramLevels', params: {deckId, groupId}})
          }
        } else {
          console.log('User Not Registered')
          const data = {
            'first_name': this.user.firstName,
            'last_name': this.user.lastName,
            'name_verified': false,
            'email': this.encryptData(this.user.email),
            'email_verified': true,
            'email_otp_generated': false,
            'country': this.user.countryId,
            'state': this.user.stateId,
            'profile_image': this.apiUrl + this.user.userImageUrl
          }
          this.setUser({...this.getUserDetails, ...data})
          this.$router.push({name: 'Register', params: {step: 'confirm-my-phone'}})
        }
      }
    },
    watch: {
      userId (val) {
        if (val) {
          this.initPage()
        }
      },
      groups () {
        if (this.groups.length > 0) {
          this.checkIfUserIsRegistered()
        }
      }
    },
    mixins: [crypto]
  }
  </script>




// WEBPACK FOOTER //
// src/components/views/Programs.vue